import { post } from '@/utils/request'

// 获取订单列表
export function getOrderList(data) {
  return post('/admin/leifeng_order/orderList', data)
}

// 获取订单详情
export function getOrderDetail(data) {
  return post('/admin/leifeng_order/orderDetail', data)
}

// 订单发货
export function orderShip(data) {
  return post('/admin/leifeng_order/orderShip', data)
}

// 取消订单
export function cancelOrder(data) {
  return post('/admin/leifeng_order/cancelOrder', data)
}

// 删除订单
export function deleteOrder(data) {
  return post('/admin/leifeng_order/deleteOrder', data)
}

// 确认收货
export function confirmReceive(data) {
  return post('/admin/leifeng_order/confirmReceive', data)
}

// 批量发货
export function orderBatchShip(data) {
  return post('/admin/leifeng_order/orderBatchShip', data)
}

// 农场订单完成
export function farmOrderFinish(data) {
  return post('/admin/leifeng_order/farmOrderFinish', data)
}
